import 'moment/locale/fr';
import { Notation } from 'notation';
import { createContext } from 'react';
import { config } from '../../core/config';
import LocalizationsState from '../../core/typings/localization';
import defaultLocalizations from './defaultLocalizations';

interface LocalizationsContextType {
  locale: string;
  translations: LocalizationsState;
  setTranslations: (TranslationsState: LocalizationsState) => void;
}

/**
 * Create a notation instance in order to use the notation
 * exapand method to mutate the translations to a nested
 * object rather than using the dot notation in the keys
 * set by the backend. Merge config.localizations with
 * defaultLocalizations to avoid missing labels
 */
const translationsNotation = new Notation(
  Object.assign(defaultLocalizations, config.localizations),
);

const LocalizationContext = createContext<LocalizationsContextType>(
  {
    locale: document.documentElement.lang,
    translations: translationsNotation.expand().value,
  } as LocalizationsContextType,
);

export default LocalizationContext;
